export default __webpack_public_path__ + "static/media/flag-uk.f2504cb1.svg";